<template>
  <v-layout
    v-if="inputValue"
    column
    class="my-2 pr-1 flex-nowrap"
    :style="{
      width: inputFieldSize + '%'
    }"
  >
    <label v-if="inputType !== 'group' && label !== ''" class="title-field">
      {{ label }}:
    </label>

    <div class="value-field">{{ inputValue }}</div>
  </v-layout>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "NetworkFields",

  props: {
    /**
     * Name of the input field
     */
    label: {
      type: String,
      required: true
    },

    /**
     * Type of input field.
     */
    inputType: {
      type: String,
      required: true
    },

    /**
     * Name of the variable to use.
     */
    value: {
      required: true
    },

    /**
     * Defines if the input field is to be hidden.
     */
    hide: {
      type: Boolean,
      default: false
    },

    /**
     * Size of the input field.
     */
    size: {
      type: String,
      required: true
    },

    /**
     * var_name of field
     */
    variableName: String,

    /**
     * Name of options list to use in the Select field.
     */
    selectOptions: String,

    /**
     * List of materials
     */
    materialOptions: Array
  },

  data() {
    return {
      /**
       * selectOptions list
       */
      listOptions: null,

      /**
       * Final value to be displayed from the field
       */
      inputValue: null
    };
  },

  computed: {
    /**
     * Defines the width of the input field.
     * @returns {number} the percentage value of the tab width used for the field.
     */
    inputFieldSize() {
      if (!isNaN(this.size)) {
        return parseInt(this.size);
      } else {
        switch (this.size) {
          case "xSmall":
            return 100 / 5;
          case "small":
            return 100 / 3;
          case "medium":
          case "large":
            return 100;
          default:
            return 100 / 5;
        }
      }
    }
  },

  mounted() {
    this.getValue();
  },

  methods: {
    ...mapActions(["GET_LIST"]),

    /**
     * Get value from field
     * @returns {Promise<void>}
     */
    async getValue() {
      let value = this.value;

      if (
        (this.inputType === "select" ||
          this.inputType === "multi-select" ||
          this.inputType === "multiselect") &&
        !this.variableName.includes("material_id")
      ) {
        await this.loadOptions();
        let option = this.listOptions.find(option => option.id == this.value);

        if (option) {
          value = option.label;
        }
      } else if (
        this.variableName.includes("material_id") &&
        this.materialOptions
      ) {
        let option = this.materialOptions.find(
          option => option.sm_id === this.value
        );
        if (option) {
          value = option.sm_short_description
            ? option.sm_short_description
            : option.sm_description;
        }
      }

      this.inputValue = value;
    },

    /**
     * Loads the select options locally.
     */
    async loadOptions() {
      let options = this.$store.getters.getListOfOptionsByListName(
        this.selectOptions,
        [this.value]
      );
      if (options && options.custom) {
        this.listOptions = Object.values(options);
        this.listOptions.pop();
        return this.listOptions;
      } else if (!options) {
        try {
          options = await this.GET_LIST({
            listName: this.selectOptions,
            code: [this.value]
          });
        } catch (error) {
          console.log(error);
        }
      }
      let finalOptions = [];
      if (options) {
        options.forEach(option => {
          finalOptions.push(this.normalizer(option));
        });
      }
      this.listOptions = finalOptions;
    },

    /**
     * Normalizes the content of each option object in the object list so it can be used in the Select input field.
     * @param {object} node - option object
     * @returns {{id: string | number, label: string}} a normalized option object.
     */
    normalizer(node) {
      let id = "";
      let label = "";
      switch (true) {
        case node.hasOwnProperty("code"):
          id = node.code;
          if (node.hasOwnProperty("client_label") && node.client_label) {
            label = node.client_label;
          } else if (node.hasOwnProperty("libelle") && node.libelle) {
            label = node.libelle;
          } else if (node.hasOwnProperty("reference") && node.reference) {
            //cableMaterialList
            label = node.reference;
          } else if (node.hasOwnProperty("name") && node.name) {
            //cableMaterialList
            label = node.name;
          } else if (
            node.hasOwnProperty("municipality_label") &&
            node.municipality_label
          ) {
            label = node.municipality_label;
          } else if (node.hasOwnProperty("libelle") && !node.libelle) {
            label = node.code;
          }
          break;
        case node.hasOwnProperty("or_id"): //OwnerList
          id = node.or_id;
          label = node.or_nom;
          break;
        case node.hasOwnProperty("pw_id"): //PathwayIdsList
          id = node.pw_id;
          label = node.pw_id;
          break;
      }
      return {
        id: id,
        label: label
      };
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Network/Forms/_Molecules/NetworkFields.vue